export const parseJsonOrEmpty = async (response: Response): Promise<unknown> => {
    const text = await response.text();

    if (!text.trim()) {
        return {};
    }

    try {
        return JSON.parse(text) as unknown;
    } catch {
        return {};
    }
};
